import { render, staticRenderFns } from "./SoluCXFooter.vue?vue&type=template&id=9f458fce&"
import script from "./SoluCXFooter.vue?vue&type=script&lang=js&"
export * from "./SoluCXFooter.vue?vue&type=script&lang=js&"
import style0 from "./SoluCXFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports